import { z } from 'zod';
import { PLATAFORMAS } from '../enums.js';
import { CPF_REGEX } from '../constants.js';
export const LoginSchema = z.object({
    email: z.string().email().max(180),
    senha: z.string().min(6).max(128),
});
// Login do app mobile (funcionario): identifica por CPF + matricula da empresa.
export const LoginFuncionarioSchema = z.object({
    cpf: z.string().regex(CPF_REGEX, 'CPF deve conter 11 digitos numericos'),
    matricula: z.string().min(1).max(40),
    deviceUuid: z.string().uuid().optional(),
});
export const RefreshSchema = z.object({
    refreshToken: z.string().min(20),
});
export const RegisterDeviceSchema = z.object({
    deviceUuid: z.string().uuid(),
    plataforma: z.enum(PLATAFORMAS),
    modelo: z.string().max(80).optional(),
    appVersion: z.string().max(40).optional(),
});
//# sourceMappingURL=auth.js.map